import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  inject,
} from '@angular/core';
import { SideSheetUtils } from '@core/utils/side-sheet.utils';
import { DvVerticalSplitterComponent } from '@devinco/ui/dds/splitter';

@Directive({
  selector: 'dv-vertical-splitter',
  standalone: false,
})
export class DvVerticalSplitterDirective implements OnInit {
  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly verticalSplitter = inject(DvVerticalSplitterComponent);

  private readonly pageName: string;
  private readonly paddingOffsetWidth = 24;

  constructor() {
    this.pageName = this.getPageName();
    this.verticalSplitter.resizableSideMinSizeInPixels = 300;
  }

  ngOnInit(): void {
    this.setupVerticalSplitterWidth();
  }

  @HostListener('resizeEnd')
  onResizeEnd(): void {
    const { id } = this.el.nativeElement;
    const width =
      (this.el.nativeElement.firstElementChild?.lastChild as HTMLElement)
        .clientWidth! ?? null;
    if (width && width > this.verticalSplitter.resizableSideMinSizeInPixels) {
      localStorage.setItem('VT_' + id + '_width', String(width));
    }
  }

  private setupVerticalSplitterWidth(): void {
    setTimeout(() => {
      const { id } = this.el.nativeElement;
      const width =
        localStorage.getItem('VT_' + id + '_width') ??
        this.getDefaultPageSideSheetWidth();
      this.verticalSplitter.resizableSideSizeInPixels = parseInt(width);
    });
  }

  private getDefaultPageSideSheetWidth(): string {
    const totalContentWidth =
      this.el.nativeElement.clientWidth + this.paddingOffsetWidth;
    const percentageWidth =
      SideSheetUtils.getDefaultWidthPercentage(this.pageName) / 100;

    return (totalContentWidth * percentageWidth).toString();
  }

  private getPageName(): string {
    const fullId = this.el.nativeElement.id;
    return fullId.replace('-vertical-splitter', '');
  }
}
